var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"root"},[_c('edit-organization',{attrs:{"organization":_vm.organization},on:{"editedOrganization":function($event){return _vm.onEditedOrganization($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }